import React from "react";

export default function Toast({ message, type }) {
  if (!message) return null;

  return (
    <div className={`neon-toast ${type}`}>
      {message}
    </div>
  );
}
